import { Injectable, Inject } from '@angular/core';
import { CORE_CONFIGURATION, IConfigurationVM } from '../models';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CryptoManagerService {
  constructor(
    @Inject(CORE_CONFIGURATION) private configurationVM: IConfigurationVM
  ) { }

  getBase64UrlFromObject = (model: any): string => {
    if (!model) return '';

    return this.toBase64UrlStringImpl(
      JSON.stringify(model || ''),
      this.configurationVM.encryptionKey
    );
  };

  getObjectFromBase64Url = (text: string): any => {
    if (!text) return null;

    const jsonString = this.fromBase64UrlStringImpl(
      text,
      this.configurationVM.encryptionKey
    );

    if (jsonString) return JSON.parse(jsonString);

    return null;
  };

  private ecryptTextImpl = (text: string, token: string): string => {
    try {
      // return btoa(text);
      return CryptoJS.AES.encrypt(text || '', token).toString();
    } catch (exception) {
      return '';
    }
  };

  private decryptTextImpl = (text: string, token: string): string => {
    try {
      // return atob(text);
      const bytes = CryptoJS.AES.decrypt(text || '', token);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (exception) {
      return '';
    }
  };

  private toBase64UrlStringImpl = (text: string, token: string): string => {
    return this.ecryptTextImpl(text, token)
      .split('+')
      .join('-')
      .split('/')
      .join('_')
      .split('=')
      .join('.');
  };

  private fromBase64UrlStringImpl = (text: string, token: string): string => {
    return this.decryptTextImpl(
      text.split('-').join('+').split('_').join('/').split('.').join('='),
      token
    );
  };
}
